"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvalidPhoneNumber = void 0;
const CademyError_1 = __importDefault(require("../../Domain/CademyError"));
class InvalidPhoneNumber extends CademyError_1.default {
    constructor(detail, status, instance) {
        const type = `generic/invalid-phone-number`;
        super(type, 'Invalid Phone Number', detail, status, instance);
    }
}
exports.InvalidPhoneNumber = InvalidPhoneNumber;
exports.default = InvalidPhoneNumber;
